import React from 'react'

import AbmPlaybookPageComponent from '../components/AbmPlaybookPageComponent'


export default function AbmPlaybook() {
  return (
    <div>
     
    <AbmPlaybookPageComponent/>
      
    </div>
  )
}
